<template>
  <div class="main">
    <div class="head">
      <div class="head_title">
        <!-- <img class="logo_img" src="@/assets/image/kanban/logo.png" alt="" /> -->
        <!-- <div>湖南大湘人力资源集团 - 数据可视化看板</div> -->

        <img class="logo_img2" src="@/assets/image/auth/logo_white.png" alt="" />
        <div style="color: #fff">湖南大湘人力资源集团 - 数据可视化看板</div>
      </div>
      <div class="current_time">{{ current_time_str }}</div>
    </div>

    <vue-particles class="lizi" color="#0466dd" :particleOpacity="0.4" :particlesNumber="80" shapeType="circle"
      :particleSize="4" linesColor="#0466dd" :linesWidth="1" :lineLinked="true" :lineOpacity="0.4" :linesDistance="150"
      :moveSpeed="3" :hoverEffect="true" hoverMode="grab" :clickEffect="true" clickMode="push">
    </vue-particles>

    <div>
      <div class="map1_1">
        <div class="map1">
          <img class="center_img1" src="@/assets/image/kanban/lbx.png" />
        </div>
      </div>

      <div class="map1_1">
        <div class="map2">
          <img class="center_img2" src="@/assets/image/kanban/jt.png" />
        </div>
      </div>

      <div class="map1_1">
        <div class="map3">
          <img class="center_img" src="@/assets/image/kanban/map.png" />
        </div>
      </div>

      <div class="map1_1" v-show="current_index == 0">
        <div id="china_map"></div>
      </div>

      <!-- <div class="map2"><img src="@/assets/image/kanban/jt.png" /></div>
    
          <div class="map3"><img src="@/assets/image/kanban/map.png" /></div> -->

      <!-- <div class="map4" id="map_1"></div> -->
    </div>

    <div class="charts_div" v-show="current_index == 0">
      <div class="charts_content">
        <div class="resume_num_box">
          <div class="resume_num_title">简历库数据概览</div>
          <div class="resume_num_row">
            <div>
              <div class="resume_num">{{ resume_total_count }}</div>
              <div class="resume_num_txt">总简历数</div>
            </div>
            <div>
              <div class="resume_num">{{ resume_man_count }}</div>
              <div class="resume_num_txt">男性人数</div>
            </div>
            <div>
              <div class="resume_num">{{ resume_woman_count }}</div>
              <div class="resume_num_txt">女性人数</div>
            </div>
          </div>

          <!-- <div>
            <div class="bingtu" id="gender"></div>
          </div> -->
        </div>
        <div class="resume_num_box">
          <div>
            <div class="bingtu" id="age"></div>
          </div>
        </div>

        <div class="yuyue_box">
          <div class="resume_num_title">项目面试实时动态</div>

          <div class="yaoyue_txt" v-for="(item, i) in recent_list" :key="i">
            <Icon type="md-volume-up" />
            {{ item }}
          </div>
        </div>
      </div>

      <div class="charts_content">
        <div class="service_box">
          <div class="charts_people">
            <div class="number1">
              {{ total_service_people_count }}
            </div>
            <div class="shu-main">
              <div class="shu"></div>
            </div>

            <div class="number1">
              {{ year_service_people_count }}
            </div>
          </div>
          <div class="charts_people_txt">
            <div class="charts_people_txt1">近3年服务总人数</div>
            <div class="shu-main">
              <div class="shu2"></div>
            </div>
            <div class="charts_people_txt1">本年服务人数</div>
          </div>
        </div>
      </div>

      <div class="charts_content_right">
        <div>
          <div class="hot_project_box">
            <div class="resume_num_title">月度热招项目Top</div>

            <div>
              <div id="hot_project"></div>
            </div>
          </div>
        </div>
        <div class="hot_project_box2">
          <div class="resume_num_title">项目行业分布</div>

          <div>
            <div id="hot_industry"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="page2" v-show="current_index == 1">
      <div class="hot_job_box">
        <div class="resume_num_title">在招岗位动态看板②</div>

        <Carousel v-if="hot_job_list_show" autoplay loop arrow="never" :autoplay-speed="3000">
          <CarouselItem v-for="(item_1, i2) in hot_job_list_1" :key="i2">
            <div class="hob_job_inner">
              <div v-for="(item, i) in item_1" :key="i" class="job_card">
                <div class="job_title">
                  {{ item.title }}
                </div>
                <div class="job_area">
                  {{ item.place_province }}-{{ item.place_city }}-{{
                    item.place_district
                  }}
                </div>
                <div class="job_address">
                  <Icon color="#3066ff" type="ios-navigate" size="18" />
                  {{ item.place_address }}
                </div>
              </div>
            </div>
          </CarouselItem>
        </Carousel>
      </div>
      <div class="hot_job_box2">
        <div class="resume_num_title">在招岗位动态看板①</div>
        <Carousel v-if="hot_job_list_show" :autoplay="true" :loop="true" arrow="never" :autoplay-speed="4000"
          @on-change="carousel_change">
          <CarouselItem v-for="(item_1, i3) in hot_job_list_2" :key="i3">
            <div class="hob_job_inner">
              <div v-for="(item, i) in item_1" :key="i" class="job_card">
                <div class="job_title">
                  {{ item.title }}
                </div>
                <div class="job_area">
                  {{ item.place_province }}-{{ item.place_city }}-{{
                    item.place_district
                  }}
                </div>
                <div class="job_address">
                  <Icon color="#3066ff" type="ios-navigate" size="18" />
                  {{ item.place_address }}
                </div>
              </div>
            </div>
          </CarouselItem>
        </Carousel>
      </div>
      <div class="hot_job_box">
        <div class="resume_num_title">在招岗位动态看板③</div>
        <Carousel v-if="hot_job_list_show" autoplay loop arrow="never" :autoplay-speed="3500">
          <CarouselItem v-for="(item_1, i) in hot_job_list_3" :key="i">
            <div class="hob_job_inner">
              <div v-for="(item, i) in item_1" :key="i" class="job_card">
                <div class="job_title">
                  {{ item.title }}
                </div>
                <div class="job_area">
                  {{ item.place_province }}-{{ item.place_city }}-{{
                    item.place_district
                  }}
                </div>
                <div class="job_address">
                  <Icon color="#3066ff" type="ios-navigate" size="18" />
                  {{ item.place_address }}
                </div>
              </div>
            </div>
          </CarouselItem>
        </Carousel>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import "echarts/extension/bmap/bmap";
import chinaJson from "@/assets/json/china.json"; // 引入中国地图数据
import { get_view_file_url, http, open_new_page } from "@/utils/http.js";

export default {
  components: {},
  data() {
    return {
      current_time_timer: null,
      current_time_str: "",

      current_index: 0,
      //
      data_refresh_timer: null,

      total_service_people_count: 0,
      year_service_people_count: 0,

      //   简历库数据
      resume_total_count: 0,
      resume_man_count: 0,
      resume_woman_count: 0,
      age_18_25_count: 0,
      age_26_35_count: 0,
      age_35_45_count: 0,
      age_45_count: 0,

      //   面试动态
      recent_list: [],

      //热招项目
      hot_project_label_list: [],
      hot_project_value_list: [],

      //
      hot_job_list_show: false,
      hot_job_list_1: [],
      hot_job_list_2: [],
      hot_job_list_3: [],
      //   服务数据刷新
      service_data_timer: null,
    };
  },

  created() {
    this.current_time();
    // this.fanyie();
    this.data_refresh();
    this.service_data_refesh();
  },
  mounted() {
    this.create_map1();

    this.create_hot_industry();

    this.get_resume_data();
    this.get_people_service_data();
    this.get_template_recent_data();
    this.get_hot_project();
    this.get_hot_job();
  },

  methods: {
    service_data_refesh() {
      if (this.service_data_timer == null) {
        clearInterval(this.service_data_timer);
      }

      var that = this;
      this.service_data_timer = setInterval(function () {
        var flag = Math.ceil(Math.random() * 10);
        console.log(flag);
        if (flag < 1) {
          var flag2 = Math.ceil(Math.random() * 10);
          that.year_service_people_count += 1;
          that.total_service_people_count += 1;
          that.resume_total_count += 1;
          that.resume_man_count += 1;
        }
      }, 20000);
    },

    fanyie() {
      if (this.fanye_timer == null) {
        clearInterval(this.fanyie_timer);
      }
      var that = this;
      this.fanye_timer = setInterval(function () {
        if (that.current_index == 0) {
          that.current_index = 1;
          setTimeout(function () {
            that.hot_job_list_show = true;
          }, 1000);
        } else {
          that.current_index = 0;
        }
      }, 6000);
    },

    data_refresh() {
      if (this.data_refresh_timer != null) {
        clearInterval(this.data_refresh_timer);
      }
      this.data_refresh_timer = setInterval(() => {
        // this.$Message.info("数据定时更新");
        // 定时刷新面试动态
        this.get_template_recent_data();
      }, 3000);
    },

    carousel_change(e) {
      console.log(e);
    },

    get_hot_job() {
      var that = this;
      var obj = {};
      http("post", process.env.VUE_APP_HOST + "/kanban/hot_job", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.hot_job_list_1 = res.data.job_list[0];
            that.hot_job_list_2 = res.data.job_list[1];
            that.hot_job_list_3 = res.data.job_list[2];
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //月度热招项目
    get_hot_project() {
      var that = this;
      var obj = {};
      http("post", process.env.VUE_APP_HOST + "/kanban/month_hot_project", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.hot_project_label_list = res.data.label_list;
            that.hot_project_value_list = res.data.value_list;
            that.create_hot_project();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    // 近期模板消息
    get_template_recent_data() {
      var that = this;
      var obj = {};
      http("post", process.env.VUE_APP_HOST + "/kanban/recent_template_data", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.recent_list = res.data.recent_list;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    get_people_service_data() {
      var that = this;
      var obj = {};
      http("post", process.env.VUE_APP_HOST + "/kanban/people_service_data", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.total_service_people_count = res.data.total_count;
            that.year_service_people_count = res.data.year_count;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    get_resume_data() {
      var that = this;
      var obj = {};
      http("post", process.env.VUE_APP_HOST + "/kanban/resume_data", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.resume_woman_count = res.data.woman_count;
            that.resume_man_count = res.data.man_count;
            that.resume_total_count = res.data.resume_total_count;
            that.age_18_25_count = res.data.age_18_25_count;
            that.age_26_35_count = res.data.age_26_35_count;
            that.age_35_45_count = res.data.age_35_45_count;
            that.age_45_count = res.data.age_45_count;

            // that.create_resume_gender();
            that.create_resume_age();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    create_hot_industry() {
      var option = {
        xAxis: {
          type: "category",
          data: [
            "智能制造",
            "汽车行业",
            "电子电器",
            "物流仓储",
            "食品饮品",
            "生物医药",
            "餐饮零售",
          ],
          axisLabel: {
            textStyle: {
              color: "#ffffff",
              fontSize: 12
            },
          },
        },
        yAxis: {
          type: "value",
        },
        grid: {
          top: 0,
          left: "3%",
          right: "3%",
          containLabel: true,
        },
        series: [
          {
            data: [420, 200, 250, 130, 70, 45, 30, 28],
            type: "bar",
            itemStyle: {
              // 为每个数据项单独设置渐变（这里以第一个数据项为例）
              normal: {
                // 注意：在 ECharts 4.x 及以上版本中，应使用 `itemStyle` 而不是 `normal`
                color: function (params) {
                  // 创建一个线性渐变对象
                  var colorList = [
                    { offset: 0, color: "#0466dd" }, // 0% 处的颜色
                    { offset: 1, color: "#0806aa" }, // 100% 处的颜色
                  ];
                  return new echarts.graphic.LinearGradient(
                    0,
                    0,
                    0,
                    1, // 渐变方向：从左上角到右下角
                    colorList // 颜色列表
                  );
                },
                // 设置圆角
                borderRadius: 10, // 可以根据需要调整这个值
              },
            },
          },
        ],
      };

      // 使用刚指定的配置项和数据显示图表。
      var myChart = echarts.init(document.getElementById("hot_industry"));
      myChart.setOption(option);
    },

    create_hot_project() {
      var that = this;
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },

        grid: {
          top: 0,
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
        },
        yAxis: {
          inverse: true,
          type: "category",
          data: that.hot_project_label_list,
          axisLabel: {
            textStyle: {
              color: "#ffffff",
              fontSize: 16
            },
          },
        },

        series: [
          {
            name: "人次",
            type: "bar",
            data: that.hot_project_value_list,
            barMaxWidth: "20px", // 可选：设置条形的最大宽度
            label: {
              show: true,
              position: "right", // 将标签显示在条形图的右侧
              textStyle: {
                color: "#cccccc", // 设置为蓝色
              },
            },
          },
        ],
      };

      // 使用刚指定的配置项和数据显示图表。
      var myChart = echarts.init(document.getElementById("hot_project"));
      myChart.setOption(option);
    },

    create_map1() {
      // 注册地图
      echarts.registerMap("china", chinaJson);

      // 初始化 ECharts 实例
      const chart = echarts.init(document.getElementById("china_map"));

      // 配置选项
      const option = {
        backgroundColor: "rgba(5,5, 5, 0)", // 设置背景为透明
        series: [
          {
            type: "map",
            map: "china", // 使用注册的中国地图
            roam: false, // 是否允许缩放和平移
            label: {
              show: false, // 不显示标签
            },
            data: [
              {
                name: "北京市",
                value: 1,
                itemStyle: { normal: { areaColor: "#e64b67" } },
              },
              {
                name: "浙江省",
                value: 1,
                itemStyle: { normal: { areaColor: "#e64b67" } },
              },
              {
                name: "湖南省",
                value: 1,
                itemStyle: { normal: { areaColor: "#e64b67" } },
              },
              {
                name: "江苏省",
                value: 1,
                itemStyle: { normal: { areaColor: "#e64b67" } },
              },
              {
                name: "上海市",
                value: 1,
                itemStyle: { normal: { areaColor: "#e64b67" } },
              },
              {
                name: "广州省",
                value: 1,
                itemStyle: { normal: { areaColor: "#e64b67" } },
              },

              {
                name: "广东省",
                value: 1,
                itemStyle: { normal: { areaColor: "#e64b67" } },
              },
            ],
            itemStyle: {
              normal: {
                areaColor: "#0466dd", // 设置区域颜色为透明
                borderColor: "#055ACD", // 设置边框颜色
                borderWidth: 1, // 设置边框宽度
              },
              emphasis: {
                areaColor: "#ffffff", // 鼠标悬停时区域颜色也为透明
              },
            },
          },
        ],
      };

      // 使用配置项生成图表
      chart.setOption(option);
    },

    create_resume_gender() {
      var chartDom = document.getElementById("gender");
      var myChart = echarts.init(chartDom);
      var option;
      var that = this;

      option = {
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "left",
          top: 20,
          textStyle: {
            color: "#fff",
            fontSize: 14,
          },
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            padAngle: 5,
            itemStyle: {
              borderRadius: 10,
            },
            label: {
              show: false,
              position: "left",
            },
            // emphasis: {
            //   label: {
            //     show: true,
            //     fontSize: 40,
            //     fontWeight: "bold",
            //   },
            // },
            labelLine: {
              show: false,
            },
            data: [
              { value: that.resume_man_count, name: "男" },
              { value: that.resume_woman_count, name: "女" },
            ],
          },
        ],
      };

      option && myChart.setOption(option);
    },

    create_resume_age() {
      var chartDom = document.getElementById("age");
      var myChart = echarts.init(chartDom);
      var option;
      var that = this;

      option = {
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "left",
          top: 20,
          textStyle: {
            color: "#fff",
            fontSize: 14,
          },
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            padAngle: 5,
            itemStyle: {
              borderRadius: 10,
            },
            label: {
              show: false,
              position: "left",
            },
            // emphasis: {
            //   label: {
            //     show: true,
            //     fontSize: 40,
            //     fontWeight: "bold",
            //   },
            // },
            labelLine: {
              show: false,
            },
            data: [
              { value: that.age_18_25_count, name: "18-25岁" },
              { value: that.age_26_35_count, name: "26-35岁" },
              { value: that.age_35_45_count, name: "35-45岁" },
              { value: that.age_45_count, name: "45岁及以上" },
            ],
          },
        ],
      };

      option && myChart.setOption(option);
    },

    padNumber(num) {
      return String(num).padStart(3, '0');
    },
    padNumber2(num) {
      return String(num).padStart(2, '0');
    },


    getBeijingTime() {
      const beijingTimeZone = "Asia/Shanghai"; // 定义北京时区
      const now = new Date(); // 获取当前时间
      const beijingDate = new Date(
        now.toLocaleString("en-US", { timeZone: beijingTimeZone })
      ); // 转换为北京时间
      return beijingDate;
    },

    current_time() {
      if (this.current_time_timer != null) {
        clearInterval(this.current_time_timer);
      }
      var that = this;
      this.current_time_timer = setInterval(() => {
        // var dt = new Date();
        var dt = that.getBeijingTime();
        var y = dt.getFullYear();
        var mt = that.padNumber2(dt.getMonth() + 1);
        var day = that.padNumber2(dt.getDate());
        var h = that.padNumber2(dt.getHours()); //获取时
        var m = that.padNumber2(dt.getMinutes()); //获取分
        var s = that.padNumber2(dt.getSeconds()); //获取秒
        that.current_time_str =
          y + "年" + mt + "月" + day + "日" + "-" + h + "时" + m + "分" + s + "秒";
        that.fanye_seconds -= 1;
      }, 1000);
    },
  },
};
</script>

<style scoped>
.page2 {
  display: flex;
  justify-content: space-between;
}

.page2-1 {
  display: flex;
  display: none;
  justify-content: space-between;
}

.job_address {
  color: #dbdbdb9d;
  margin-top: 5px;
}

.job_title {
  color: #ffffffe0;
  font-size: 16px;
}

.job_card {
  padding: 10px;
}

.job_area {
  margin-bottom: 5px;
  color: #f3f3f380;
  text-align: right;
}

.hob_job_inner {
  width: 100%;
  padding: 10px;
  height: calc(100vh - 190px);
  overflow: auto;
  z-index: 999;
}

.hot_job_box2 {
  width: 700px;
  height: calc(100vh - 120px);
  z-index: 999;
  margin: 10px 30px 10px 10px;
  border: 1px solid #ececec23;
  border-radius: 10px;

  padding: 10px 10px 10px 0;
  background-image: url("@/assets/image/kanban/line.png");
}

.hot_job_box {
  width: 450px;
  height: calc(100vh - 120px);
  z-index: 999;
  margin: 10px 30px 10px 10px;
  border: 1px solid #ececec23;
  border-radius: 10px;

  padding: 10px 10px 10px 0;
  background-image: url("@/assets/image/kanban/line.png");
}

.hob_job_inner::-webkit-scrollbar {
  width: 0;
}

/* 隐藏水平滚动条 */

.hob_job_inner::-webkit-scrollbar {
  height: 0;
}

.hot_job_box::-webkit-scrollbar {
  display: none;
}

.yaoyue_txt {
  font-size: 15px;
  color: #fff;
  padding: 5px;
  background: #224172;
  margin-bottom: 5px;
  border-radius: 5px;
}

.resume_num_row {
  padding: 0 0 20px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.bingtu {
  width: 400px;
  height: 200px;
}

#hot_project {
  width: 500px;
  height: 300px;
}

#hot_industry {
  width: 500px;
  height: 400px;
}

.resume_num_box {
  width: 460px;
  margin: 0 10px 10px 30px;
  border: 1px solid #ececec23;
  border-radius: 10px;
  padding: 10px 10px 0 10px;
  background-image: url("@/assets/image/kanban/line.png");
}

.yuyue_box {
  width: 460px;
  height: 600px;
  margin: 0 10px 10px 30px;
  overflow: auto;
  border: 1px solid #ececec23;
  overflow: hidden;
  border-radius: 10px;
  padding: 10px 10px 0 10px;
  background-image: url("@/assets/image/kanban/line.png");
}

.hot_project_box {
  width: 500px;
  height: 400px;
  margin: 0 30px 0px 10px;
  border: 1px solid #ececec23;
  border-radius: 10px;
  padding: 10px 10px 10px 0;
  background-image: url("@/assets/image/kanban/line.png");
}

.hot_project_box2 {
  width: 500px;
  height: 400px;
  position: relative;
  top: -30px;
  margin: 0 30px 0px 10px;
  border: 1px solid #ececec23;
  border-radius: 10px;
  padding: 10px 10px 10px 0;
  background-image: url("@/assets/image/kanban/line.png");
}

.hot_industry_box {
  width: 500px;
  height: 300px;
  margin: 10px 30px 10px 10px;
  border: 1px solid #ececec23;
  border-radius: 10px;
  padding: 10px 10px 10px 0;
  background-image: url("@/assets/image/kanban/line.png");
}

#china_map {
  width: 800px;
  height: 800px;
  position: relative;
  top: 100px;
}

.lizi {
  position: absolute;
  left: 0;
  width: 100vw;
  height: calc(100vh - 100px);
}

.number1 {
  font-family: "DSDIGIT";
  font-size: 46px;
  letter-spacing: 5px;
  color: #f2f480;
  width: calc(50% - 25px);
  text-align: center;
}

.charts_content {
  width: 42%;
}

.charts_content_right {
  width: 38%;
  display: flex;
  justify-content: end;
  flex-wrap: wrap;
  text-align: right;
}

.service_box {
  background: rgba(101, 132, 226, 0.1);
  padding: 0.15rem;
}

.shu-main {
  width: 50px;
  justify-content: center;
}

.charts_div {
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
}

.charts_people_txt1 {
  width: calc(50% - 25px);
  text-align: center;
  color: #ccc;
  font-size: 16px;
}

.logo_img {
  position: relative;
  bottom: 5px;
  width: 50px;
  height: 35px;
  margin-right: 5px;
}

.logo_img2 {
  position: relative;
  bottom: 5px;
  width: 50px;
  height: 50px;
  margin-right: 5px;
}

.charts_people_txt {
  display: flex;
  margin-top: 10px;
  justify-content: space-between;
}

.charts_people {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  border: 0.2px solid #ececec1e;
}

.current_time {
  font-size: 14px;
  position: absolute;
  right: 10px;
  font-weight: 400;
  color: #ffffffe1;
}

.shu {
  height: 30px;
  width: 1px;
  background: #aaaaaa;
  margin: 0 20px;
}

.shu2 {
  height: 30px;
  width: 1px;
  margin: 0 20px;
}

.center_img1 {
  width: 550px;
  height: 550px;
}

.center_img2 {
  width: 500px;
  height: 500px;
}

.center_img {
  width: 450px;
  height: 450px;
}

.map1_1 {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 100px);
  width: 100vw;
  position: absolute;
  left: 0;
  overflow: hidden;
  /* 隐藏容器内的滚动条 */
}

.map1 {
  display: flex;
  justify-content: center;
  align-items: center;
  /* padding:15em 0 0 0em; */
  opacity: 0.4;
  animation: shunshizhen 8s linear infinite;
}

@keyframes shunshizhen {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.map3 {
  display: flex;
  justify-content: center;
  align-items: center;
  /* padding:15em 0 0 0em; */
  opacity: 0.4;
}

.map2 {
  display: flex;
  justify-content: center;
  align-items: center;
  /* padding:15em 0 0 0em; */
  opacity: 0.4;
  animation: nishizhen 8s linear infinite;
}

@keyframes nishizhen {
  from {
    transform: rotate(360deg);
  }

  to {
    transform: rotate(0deg);
  }
}

.resume_num_title {
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 3px;
  color: #f2f480;
  margin-bottom: 20px;
  text-align: center;
}

.resume_num_txt {
  color: #ccc;
  font-family: "DingTalk_JinBuTi";
}

.resume_num {
  color: #fff;
  letter-spacing: 3px;
  font-size: 20px;
  font-family: "DingTalk_JinBuTi";
}

.head_title {
  display: flex;
  align-items: center;
}

.head {
  height: 80px;

  background-size: 100% 100%;
  position: relative;
  z-index: 100;
  background-image: url("/src/assets/image/kanban/head_bg.png");
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 26px;
  font-weight: 600;
  letter-spacing: 3px;
  color: #ffd22d;
}

.main {
  background-image: url("/src/assets/image/kanban/bg.jpg");
  background-size: 100% calc(100vh - 100px);
  height: 100vh;
  overflow: hidden;
}
</style>
